<template>
  <div>
    <b-container fluid class="pt-3 row">
      <div class="col-md-8 col-lg-8 col-sm-8 col-xs-12 col-xs-12">
        <h5>扫码入账</h5>
        <h6 class="mb-4 text-muted">扫描发票二维码进行入账处理，入账之后可以防止重复报销</h6>
        <form>
          <div class="form-group">
            <b-form-textarea
              id="textarea"
              v-model="param.qrcode"
              :autofocus="true"
              placeholder="切换至英文输入法，光标放入该文本框，用扫描枪扫码发票上面的二维码"
              rows="5"
              max-rows="5"
              no-auto-shrink
              style="resize:none"
              @keydown.enter="scan"
            ></b-form-textarea>
            <!-- <div class="text-danger">注意：切换至英文输入法，并且将光标放入上面输入框</div> -->
            <b-form-input
              v-model="accountParam.expenseEmpName"
              placeholder="请输入报销人姓名"
              class="my-2"
            ></b-form-input>

          </div>
          <button type="button" @click="manualAccount()" class="btn btn-primary">入账</button>
          <p class="mt-2">如果二维码无法识别或者识别不全，您可以 <button type="button" @click="manualInput()" class="btn btn-outline-primary">手工入账</button> 或者 
            <button type="button" v-b-modal.qrCodeModal class="btn btn-outline-primary">手机拍照上传</button>
          </p>
        </form>
      </div>

      <div class="col-md-4 col-lg-4 col-sm-4 col-xs-12">
        <b-alert :show="code=='0'" variant="success">
          <h4 class="alert-heading">入账成功</h4>
          <hr />
          <div style="font-size:14px">
            <ul class="col-md-12 list-unstyled">
              <li>发票类型：{{invoice.cataName}}</li>
              <li>购货单位：{{invoice.buyerName}}</li>
              <li>销货单位：{{invoice.sellerName}}</li>
              <li>发票代码：{{invoice.invCode}}</li>
              <li>发票号码：{{invoice.invNo}}</li>
              <li>开票日期：{{invoice.issueDate}}</li>
              <li>价税合计：{{invoice.totalAmount}}</li>
            </ul>
          </div>
          <div class="d-flex flex-row-reverse">
            <b-button
              variant="danger"
              class="mb-0 pull-right"
              size="sm"
              @click="openAccountDialog(invoice,'unaccount')"
            >取消入账</b-button>
          </div>
        </b-alert>

        <b-alert :show="code=='1'" variant="danger" style="font-size:14px">
          <strong>入账失败!</strong>
          {{this.message}}
          <b-button
            variant="danger"
            class="mb-0 pull-right"
            size="sm"
            v-if="invoice.accStatus=='1'"
            @click="openAccountDialog(invoice,'unaccount')"
          >取消入账</b-button>
        </b-alert>
      </div>
    </b-container>
    <b-row ref="queryFormWrapper" class="mt-4" style="height:500px;">
      <b-col cols="12"></b-col>

      <b-toast
        :id="invoice.id"
        :variant="getColor(code)"
        solid
        :no-auto-hide="true"
        :append-toast="true"
        :key="invoice.id"
      >
        <template #toast-title>
          <div class="d-flex flex-grow-1 align-items-baseline">
            <strong class="mr-auto">{{code=='0'?'发票入账成功':'发票入账失败'}}</strong>
            <small class="text-muted mr-2">{{currentDate}}</small>
          </div>
        </template>
        <template #default>
          <div class="align-items-baseline">
            <div style="min-height:35px;">{{message}}</div>
            <div>
              <b-button
                variant="danger"
                class="mr-2 pull-right"
                size="sm"
                @click="openAccountDialog(invoice,'unaccount')"
              >取消入账</b-button>
            </div>
          </div>
          <div></div>
        </template>
      </b-toast>
    </b-row>

    <loading :show="pageLoading"></loading>

    <b-modal
      id="accountModal"
      title="入账"
      incline
      v-model="accountDialogVisible"
      @ok="handleAccount('account')"
    >
      <template slot="modal-ok">入账</template>
      <template slot="modal-cancel">取消</template>

      <form ref="uploadParam">
        <b-form-group label-cols-sm="2" label-align-sm="right">
          <template slot="label">
            <span class="text-danger">*</span>选择企业:
          </template>
          <b-form-select
            style="min-width:130px;"
            class="ml-2"
            :options="accEntList"
            v-model="accountParam.entCode"
          ></b-form-select>
        </b-form-group>
      </form>
    </b-modal>

    <!-- 显示手工查验对话框 -->
    <b-modal
      id="manualCheckModal"
      title="手工审核"
      incline
      v-model="manualCheckDialogVisible"
      @ok="handleManualCheck"
    >
      <template slot="modal-ok">查验</template>
      <template slot="modal-cancel">取消</template>

      <form>
        <validation-observer ref="manualCheckForm">
          <validation-provider :rules="{required:true}" name="票种" v-slot="validationContext">
            <b-form-group label="票种" :invalid-feedback="validationContext.errors[0]">
              <b-form-select
                style="min-width:100px;"
                class="m-1"
                :options="invCataList"
                v-model="invoiceCheckDto.invCataCode"
                @change="onInvCataCodeChange"
              ></b-form-select>
            </b-form-group>
          </validation-provider>

          <validation-provider
            :rules="{required:false}"
            name="发票代码"
            v-slot="validationContext"
          >
            <b-form-group
              label="发票代码"
              :invalid-feedback="validationContext.errors[0]"
              label-for="input_username"
              v-if="invCodeVisiible"
            >
              <b-form-input
                v-model="invoiceCheckDto.invCode"
                :state="validateState(validationContext)"
                placeholder="请输入10-12位发票代码,数电票无需输入"
              ></b-form-input>
            </b-form-group>
          </validation-provider>

          <validation-provider
            :rules="{required:true, min:8, max:20}"
            name="发票号码"
            v-slot="validationContext"
          >
            <b-form-group label="发票号码" :invalid-feedback="validationContext.errors[0]">
              <b-form-input
                v-model="invoiceCheckDto.invNo"
                :state="validateState(validationContext)"
                placeholder="请输入8位发票号码,数电发票为20位"
              ></b-form-input>
            </b-form-group>
          </validation-provider>

          <validation-provider
            :rules="{required:true, min:8,max:8}"
            name="开票日期"
            v-slot="validationContext"
          >
            <b-form-group label="开票日期(格式为YYYYMMDD)" :invalid-feedback="validationContext.errors[0]">
              <b-form-input
                v-model="invoiceCheckDto.invIssueDate"
                :state="validateState(validationContext)"
              ></b-form-input>
            </b-form-group>
          </validation-provider>

          <validation-provider :rules="{required:false}" :name="verifyAmountLable" v-slot="validationContext">
            <b-form-group :label="verifyAmountLable" :invalid-feedback="validationContext.errors[0]">
              <b-form-input
                v-model="invoiceCheckDto.invNoTaxAmount"
                :state="validateState(validationContext)"
                placeholder="数电发票输入价税合计金额，税控发票输入不含税金额"
              ></b-form-input>
            </b-form-group>
          </validation-provider>

          <validation-provider :rules="{max:20, min:6}" name="校验码" v-slot="validationContext">
            <b-form-group label="校验码" :invalid-feedback="validationContext.errors[0]">
              <b-form-input
                v-model="invoiceCheckDto.invCheckCode"
                :state="validateState(validationContext)"
                placeholder="请输入20位校验码,或者最后6位"
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </validation-observer>
      </form>
    </b-modal>
    <!-- 显示手工查验对话框结束 -->

    <!-- 手机拍照对话框 -->
    <b-modal
      id="qrCodeModal"
      title="手机扫描该二维码"
      incline
    >
      <p>如果在手机中无法打开该二维码，请刷新页面后重新扫码</p>
      <p>上传成功后，在<b-link href="#/invcheck">发票审核</b-link>页面点击查询按钮，将会看到上传结果</p>
      <vue-qr :logoSrc="imageUrl" :text="qrCodeUrl" :size="200"></vue-qr>
    </b-modal>


  </div>
</template>

<script>
import * as invoiceFacade from "../../../api/invoice-facade.js";
import * as accountFacade from "../../../api/account-facade.js";
import * as entFacade from "../../../api/ent-facade.js";
import dayjs from "dayjs";
import util from '@/libs/util'
import vueQr from 'vue-qr'

import { mapState } from "vuex";

export default {
  // validations:
  data() {
    return {
      accEntList: [],
      invoice: {},
      param: {
        qrcode: ""
      },

      accountParam: {
        entCode: "",
        invoiceId: "",
        expenseEmpName: "",
      },
      code: "",
      message: "",
      currentDate: "",
      invoiceCheckDto:{
        invCataCode: "10"
      },

      pageLoading: false,

      opIndex: -1, // 当前操作的表格行索引
      // 以上为页面状态控制参数
      accountDialogVisible: false,
      manualCheckDialogVisible: false,
      // 以下为表单校验规则

      invCodeVisiible:true,

      // 查验金额label
      verifyAmountLable:'不含税金额',
      // 以上为表单校验规则
      invCataList: [
        { text: "增值税电子普通发票", value: "10" },
        { text: "增值税电子专用发票", value: "20" },
        { text: "全电发票(增值税专用)", value: "31" },
        { text: "全电发票(增值税普通)", value: "32" },
        { text: "增值税专用发票", value: "01" },
        { text: "增值税普通发票", value: "04" },
        { text: "增值税卷式发票", value: "11" }
      ],

      qrCodeUrl:"",
      imageUrl: require("../../../assets/logo.png"),

    };
  },
  // watch: {
  //   "param.qrcode"() {
  //     if (this.param.qrcode != "" && this.param.qrcode.length > 30) {

  //       let arr = this.param.qrcode.split(",");
  //       let length = arr.length;
  //       let val = arr[length - 1];
  //       let valid = false;

  //       if (length == 8 ) {
  //         valid = true;
  //         console.log("valid")
  //       }
  //       // if (length == 8 && val.length >= 4) {
  //       //   valid = true;
  //       // }
  //       // if (length == 9 && val.length == 0) {
  //       //   valid = true;
  //       // }
  //       if (!valid) {
  //         // this.code = "1";
  //         // this.invoice.id = "error";
  //         // this.message = "二维码不符合发票二维码规则(length<7),无法解析";
  //         //console.log(this.param.qrcode)
  //         //console.log("二维码不符合发票二维码规则(length<7),无法解析")
  //       } else {
  //         console.log("次数" + this.param.qrcode)
  //         //this.handleQuery(this.param.qrcode);
  //       }
  //     }
  //   }
  // },
  components: {
      vueQr
  },
  computed: {
    ...mapState("admin/user", ["info"])
  },

  created() {
    this.initInfo();
  },
  mounted() {
    //
    this.creatQrCode()

  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    showToast() {
      // this.$nextTick(() => {
      //   this.$bvToast.show(this.invoice.id);
      // });
    },
    hideToast() {
      // this.$nextTick(() => {
      //   this.$bvToast.hide(this.invoice.id);
      // });
      this.code = "-1";
    },
    //获取颜色
    getColor(code) {
      if (code == "0") {
        return "success";
      }
      if (code == "1") {
        return "danger";
      }
    },
    //打开记账dialog
    openAccountDialog(item, type) {
      let buyerTaxCode = item.buyerTaxCode;
      this.accountParam.invoiceId = item.id;

      if (!buyerTaxCode && type == "account") {
        this.accountDialogVisible = true;
        return;
      }
      this.accountParam.entCode = buyerTaxCode;
      if (type == "account") {
        this.handleAccount();
        return;
      }
      let typeStr = type == "account" ? "入账" : "取消入账";

      this.$bvModal
        .msgBoxConfirm("确认" + typeStr + "吗？", {
          title: typeStr,
          size: "sm",
          buttonSize: "md",
          okVariant: "primary",
          okTitle: typeStr,
          cancelTitle: "取消",
          footerClass: "p-2",
          hideHeaderClose: false
        })
        .then(value => {
          if (value) {
            type == "account"
              ? this.handleAccount()
              : this.handleCancelAccount();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //记账or取消记账动作执行
    handleAccount() {
      //记账
      this.pageLoading = true;
      this.code = "-1";
      accountFacade
        .accountByInvoiceId(this.accountParam)
        .then(() => {
          this.pageLoading = false;
          this.code = "0";

          // this.message =
          //   "发票代码：" +
          //   this.invoice.invCode +
          //   "，发票号码：" +
          //   this.invoice.invNo +
          //   "，" +
          //   "开票日期：" +
          //   this.invoice.issueDate +
          //   "，不含税金额：" +
          //   this.invoice.noTaxAmount +
          //   "，购方名称：" +
          //   this.invoice.buyerName +
          //   "，购方税号：" +
          //   this.invoice.buyerTaxCode;
          this.showToast();
          this.param.qrcode = "";
        })
        .catch(err => {
          this.pageLoading = false;

          console.log("err", err);
        });
      this.accountParam.entCode = "";
      this.accountParam.invoiceId = "";
    },
    handleCancelAccount() {
      //记账

      this.pageLoading = true;
      this.code = "-1";
      accountFacade
        .cancelAccountByInvoiceId(this.accountParam.invoiceId)
        .then(() => {
          this.pageLoading = false;
          this.hideToast();
          this.$message({
            message: "取消入账成功",
            type: "success"
          });
          this.param.qrcode = "";
        })
        .catch(err => {
          this.pageLoading = false;
          console.log("err", err);
        });
    },

    // 执行查询操作
    handleQuery(qrcode) {
      let expenseEmpName = 
      this.pageLoading = true;
      invoiceFacade
        .obtainByQrCode(qrcode)
        .then(res => {
          this.invoice = res;
          this.pageLoading = false;
          this.currentDate = dayjs().format("YYYY-MM-DD HH:mm:ss");
          // let buyerTaxCode = res.buyerTaxCode;
          //记账状态
          let accStatus = res.accStatus;
          //未记账
          if (accStatus == "0") {
            this.openAccountDialog(res, "account");
          }
          // 已经记账
          if (accStatus == "1") {
            this.code = "1";
            this.message = "该发票已经被入账，请勿重复入账.";

            this.showToast();
            //提示已经记账
            this.param.qrcode = "";
          }
          // this.pageLoading = false;
          // this.$message({
          //   message: "取消记账成功",
          //   type: "success"
          // });
        })
        .catch(err => {
          this.pageLoading = false;
          console.log("err", err);
        });
    },
    //手工点击记账按钮
    manualAccount() {
      this.code = "-1";
      if (this.param.qrcode != "") {
        if (this.param.qrcode.length > 40) {
          let arr = this.param.qrcode.split(',');
          if (arr.length < 7) {
            console.log(arr.length)
            console.log(this.param.qrcode)
            this.code = "1";
            this.invoice.id = "error";
            this.message = "二维码不符合发票二维码规则(length<7),无法解析";
          } else {
            this.handleQuery(this.param.qrcode);
          }
        } else {
          this.code = "1";
          this.invoice.id = "error";
          this.message = "二维码不符合发票二维码规则(length<7),无法解析！";
        }
      } else {
        this.invoice = {};
        this.code = "1";
        this.invoice.id = "error";
        this.message = "发票二维码未扫描";
      }
    },
    //初始化信息
    initInfo() {
      this.getEntInfo();
    },
    getEntInfo() {
      this.pageLoading = true;
      entFacade
        .findByUserRole()
        .then(res => {
          this.parseEntInfo(res);
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },
    //解析企业信息
    parseEntInfo(res) {
      this.pageLoading = false;
      let accEntList = [];
      if (res) {
        res.map(item => {
          let ent = {};
          ent.text = item.entName;
          ent.value = item.entCode;
          accEntList.push(ent);
        });
      }

      this.accEntList = accEntList;
      if (this.accEntList.length > 0) {
        this.accountParam.entCode = this.accEntList[0].value;
      }
    },

    manualInput(){
      // 解析文本框中的二维码
      let arr = this.param.qrcode.split(',');
      if(arr.length >= 7){
        this.invoiceCheckDto.invCataCode = arr[1]
        this.invoiceCheckDto.invCode = arr[2]
        this.invoiceCheckDto.invNo = arr[3]
        this.invoiceCheckDto.invNoTaxAmount = arr[4]
        this.invoiceCheckDto.invIssueDate = arr[5]
        this.invoiceCheckDto.invCheckCode = arr[6]
      }

      this.onInvCataCodeChange(this.invoiceCheckDto.invCataCode)
      this.manualCheckDialogVisible=true

    },

    // 选择分类事件
    onInvCataCodeChange(item){
      if(item=="31" || item=="32"){
        this.invCodeVisiible=false
        this.verifyAmountLable='价税合计金额'
      }else{
        this.invCodeVisiible=true
        this.verifyAmountLable='不含税金额'
      }
    },

    // 手工发票入账
    handleManualCheck(e) {
      // 调用手工审核的方法
      e.preventDefault();

      //this.nameState = this.$refs.form.checkValidity();
      this.$refs.manualCheckForm.validate().then(success => {
        if (!success) {
          return;
        }

        // 首先生成二维码
        let qrcode = "01,"
        qrcode += this.invoiceCheckDto.invCataCode + ","
        qrcode += (this.invoiceCheckDto.invCode ? this.invoiceCheckDto.invCode : "")+ ","
        qrcode += this.invoiceCheckDto.invNo + ","
        qrcode += (this.invoiceCheckDto.invNoTaxAmount ? this.invoiceCheckDto.invNoTaxAmount : "0.00") + ","
        qrcode += this.invoiceCheckDto.invIssueDate + ","
        qrcode += (this.invoiceCheckDto.invCheckCode ? this.invoiceCheckDto.invCheckCode : "000000") + ","

        // 根据二维码到发票表中获取发票，如果没有则执行发票验真
        // 最后执行记账处理
        this.handleQuery(qrcode);

        this.manualCheckDialogVisible = false;
      });
    },    

    // 执行扫描枪的扫码
    scan(){
      let arr = this.param.qrcode.split(',');
      let length = arr.length;
      console.log(arr)
      console.log(length)
      if(length < 7){
        this.code = "1";
        this.invoice.id = "error";
        this.message = "二维码不符合发票二维码规则(length<7),无法解析";
        return;
      }
      // 执行扫码
      this.handleQuery(this.param.qrcode);
    },

    // 输出二维码
    creatQrCode() {
      const token = util.cookies.get('token')
      let orgId = this.info.orgId;
      let url = process.env.VUE_APP_WEB_ROOT_PATH + "/#/camera?token=" + token + "&orgId=" + orgId;
      console.log(url)

      this.qrCodeUrl = url;
    },

  }
};
</script>

<style >
.b-toaster.b-toaster-top-right,
.b-toaster.b-toaster-top-left,
.b-toaster.b-toaster-top-center,
.b-toaster.b-toaster-top-full {
  top: 65px !important;
  right: 15px !important;
  z-index: 1 !important;
}
.vs__dropdown-toggle {
  height: 33.5px;
}
.toast-body {
  height: 100px;
}
</style>
